import type { GetStyles, ShadowCode, ShadowStyledProps, Split, Theme } from '@sds-system/types';

export const getShadowValue = (shadowCode: ShadowCode, theme: Theme) => {
  if (!shadowCode) {
    throw new Error('shadowCode 존재하지 않습니다.', { cause: 'not required' });
  }

  const splitShadowCode = shadowCode.split('.') as Split<'.', ShadowCode>;
  const shadowPosition = splitShadowCode[0];
  const shadowType = splitShadowCode[1];

  return theme.shadow[shadowPosition][shadowType];
};

export const getShadowStyles: GetStyles<ShadowStyledProps> = ({ theme, shadow }) => {
  if (shadow) {
    return {
      boxShadow: getShadowValue(shadow, theme),
    };
  }
  return {};
};
